export default {
  path: '/error-thresholds/:id',
  component: () =>
    import(
      '@/components/pages/ErrorThresholds/ErrorThreshold.vue'
    )
}
